import { useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

export default function useCampaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    api.get(`${QUALITY_SERVICE_API_URL}/hub/campaigns`, { signal: controller.signal })
      .then(res => {
        setCampaigns(res.data ?? []);
        setError(null);
        setLoading(false);
      })
      .catch(err => {
        if (err.code === 'ERR_CANCELED') return;
        setError(err);
        setLoading(false);
      });

    return () => controller.abort();
  }, []);

  return { campaigns, loading, error };
}
